import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MegamenuComponent } from '../megamenu/megamenu.component';
import { FooterComponent } from '../footer/footer.component';
import { CompanyConfigService, CompanyConfig } from '../../services/company-config.service';

interface TeamMember {
  name: string;
  title: string;
  image: string;
  bio: string;
  email?: string;
  phone?: string;
  specialties: string[];
  experience: string;
  isOpenPosition?: boolean;
}

@Component({
  selector: 'app-our-team',
  templateUrl: './our-team.component.html',
  styleUrl: './our-team.component.css',
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MegamenuComponent,
    FooterComponent
  ]
})
export class OurTeamComponent {
  config: CompanyConfig;

  teamMembers: TeamMember[] = [
    {
      name: 'Marc Santiago',
      title: 'Founder and Managing Director',
      image: '/assets/Marc.jpg',
      bio: 'Marc founded Complete Pest Control and leads the company’s day-to-day operations. He focuses on building efficient service processes, supporting the team in the field, and ensuring every customer receives professional, high-quality pest control service. With a strong background in pest management and service operations, Marc works closely with the team to improve service delivery and maintain the standards that guide the company’s work. He is committed to building a business known for reliability, professionalism, and long-term relationships within the communities the company serves.',
      specialties: [
        'Pest Control Operations',
        'Field Team Leadership',
        'Service Quality Standards',
        'Operational Efficiency',
        'Process Improvement'
      ],
      experience: '15+ years in pest control operations and service management',
      isOpenPosition: false
    },
    {
      name: 'Angel Santiago',
      title: 'Co-Founder & Director of Operations',
      image: '/assets/Angel.jpg',
      bio: 'Angel co-founded Complete Pest Control and oversees the internal operations that keep the company running smoothly. She coordinates scheduling, administrative processes, and organizational systems that support both the field technicians and the overall customer experience. With a background in business management and operational planning, Angel focuses on maintaining efficient workflows, clear communication, and consistent service standards while helping the company grow in a structured and sustainable way.',
      specialties: [
        'Operations Management',
        'Scheduling & Logistics',
        'Administrative Systems',
        'Business Process Coordination',
        'Organizational Management'
      ],
      experience: '12+ years in business operations and organizational management.',
      isOpenPosition: false
    },
    {
      name: 'Jason Hermann',
      title: 'Director of Technology',
      image: '/assets/Jason3.jpg',
      bio: 'Jason leads the technology initiatives that support Complete Pest Control’s operational systems. He oversees the tools used for service management, customer records, scheduling, and internal workflows that help the team operate efficiently. By combining a strong background in technology with an understanding of pest management operations, Jason helps connect modern digital solutions with practical field applications. His work focuses on improving processes, enhancing efficiency, and supporting the continued development of the company’s software and digital infrastructure.',
      specialties: [
        'Technology Integration',
        'Service Management Systems',
        'Process Automation',
        'Data & Workflow Optimization',
        'Customer Experience Systems'
      ],
      experience: '19+ years developing technology systems and operational tools',
      isOpenPosition: false
    },
    {
      name: 'Join our Team!',
      title: 'Director of Sales',
      image: 'profile_icon', // Special flag for profile icon
      bio: "Complete Pest Control is growing and looking for a Director of Sales to help guide the company’s next stage of expansion. This role focuses on building strong customer relationships, developing effective sales strategies, and helping strengthen the company’s presence in the communities we serve. The Director of Sales will play an important role in shaping how the company continues to grow while supporting the team responsible for delivering high-quality service. If you enjoy building teams, driving growth, and contributing to a company focused on professionalism and long-term success, we encourage you to apply.",
      specialties: [
        'Sales Leadership',
        'Team Building',
        'Customer Relations',
        'Business Development',
        'Market Growth'
      ],
      experience: 'We\'re looking for 5+ years in sales leadership',
      isOpenPosition: true
    }
    // Additional team members can be added here as the company grows
  ];

  constructor(private companyConfig: CompanyConfigService) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  sendEmail() {
    this.companyConfig.sendEmail();
  }
}